










































































import {
  Component,
  Vue,
  Emit,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import Loader from "@/components/Loader.vue";
import PropertyCreator from "@/components/property/PropertyCreator.vue";
import { IPublisher } from "../../models/interfaces/publisher/publisher.model.interface";
import { IProperty } from "../../models/interfaces/property/property.model.interface";
import { StatusType } from "@/enums/StatusType";
import { Property } from "@/models/property/property.model";

const PropertyManagementModule = namespace("propertyManagementModule");

@Component({
  components: {
    Loader,
    PropertyCreator
  }
})
export default class PropertiesTable extends Vue {
  @PropertyManagementModule.Action public pauseProperty;
  @PropertyManagementModule.Action public setPropertyLive;

  get getProperties(): IProperty[] {
    return this.publisher.properties;
  }

  @Prop() public loading: boolean;

  @Prop() public publisher: IPublisher;

  @Prop({ default: "Table" })
  public caption: string;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: true })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: true })
  public fixed: boolean;

  @Provide() public items: IProperty[] = [];

  @Provide()
  public columns = [
    {
      key: "name",
      label: "Property",
      sortable: true,
      formatter: (value, key, item) => {
        return item;
      }
    },
    {
      key: "domain",
      sortable: true
    },
    {
      key: "propertyCode",
      label: "TLA Property Id",
      sortable: true
    },
    {
      key: "state",
      label: "Status",
      sortable: true,
      formatter: (value, key, item) => {
        return item;
      }
    }
  ];

  @Provide() public currentPage = 1;
  @Provide() public perPage = 10;
  @Provide() public totalRows = 0;

  private filter: string | null = null;

  private show: boolean = false;

  private selectedProperty: IProperty = new Property();

  get modalText(): string {
    if (this.selectedProperty.state.statusType === StatusType.Live) {
      return `Are you sure you want to pause ${this.selectedProperty.name}?`;
    }
    return `Are you sure you want to set ${this.selectedProperty.name} live?`;
  }

  get showPagination(): boolean {
    return this.items.length > this.perPage;
  }

  public showModal(property: IProperty) {
    this.selectedProperty = property;
    this.show = true;
  }

  public hideModal() {
    this.show = false;
  }

  public completeAction() {
    if (this.selectedProperty.state.statusType === StatusType.Live) {
      this.pauseProperty(this.selectedProperty).then((result) => {
        this.hideModal();
      });
    } else {
      this.setPropertyLive(this.selectedProperty).then((result) => {
        this.hideModal();
      });
    }
  }

  @Watch("getProperties", { deep: true })
  public onPropertiesUpdate() {
    this.updateItems();
  }

  public getRowCount(items) {
    return items.length;
  }

  public updateItems() {
    this.items = this.getProperties;
  }

  public onFiltered(filteredItems) {
    // Trigger pagination to update the number of buttons/pages due to filtering
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }

  public created() {
    this.updateItems();
  }
}
